import {getPaymentRequests, updatePaymentRequests} from "../api/payment_request";
import {makeid} from "../helpers";

export default {
    data:() => {
        return{
            filters:{
                is_request:false,
                done: 0,
            },
            links:[],
            selected:[],
            show:false,
            data:null,
            undone: {show:false}
        }
    },
    computed:{
        filteredVi(){
            if(this.data){
                var data = this.data.filter(x => x.goes_to == 'vi');
                return data.filter(x => {
                    return x.is_request == this.filters.is_request && x.done == this.filters.done
                })
            }
            return []
        },
        filteredWebsite(){
            if(this.data){
                var data = this.data.filter(x => x.goes_to == 'website');
                return data.filter(x => {
                    return x.is_request == this.filters.is_request && x.done == this.filters.done
                })
            }
            return []
        }
    },
    methods:{
        getUndone(){
            getPaymentRequests({undone: true}).then(response => {
                this.undone.show = true;
                this.$set(this.undone, 'data', response);
            })
        },
        getData(){
            getPaymentRequests().then(response => {
                this.data = response.data;
                this.links = response.links
            })
        },
        makePaymentRequest(){
            return new Promise((resolve, reject) => {
                var ids = this.selected.map(item => {
                    return item.id;
                })
                var hash = makeid(200);
                var obj = {hash: hash};
                updatePaymentRequests({ids:ids, data: obj}).then(response => {
                    this.getData();
                    resolve();
                })
            })
        },
        showToggle(){
            this.show = !this.show;
            if(this.show == true){
                this.getData();
            }
        }
    }
}
